import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { logout } from 'src/common/index';
import { IconLabel } from 'src/components/administration/IconLabel';

class Logout extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.logout();
    }

    render() {
        const { t } = this.props;
        return (
            <form id="form" onSubmit={this.handleSubmit}>
                <button className="btn btn-link nav-link" title={t('header_logout')} type="submit">
                    <IconLabel icon="log-in" text={t('header_logout')} collapse />
                </button>
            </form>
        );
    }
}

export default withTranslation()(connect(null, { logout })(Logout));
